module.exports = __webpack_public_path__ + "static/product-page-product-info-under-options-a28d8d3e1914b27de004762fe44fbcc3.jpg";